import axiosInstance from "../../../../api/axiosInstance";
import { endpoints } from "../../../../services/endpoints";
import { deleteQuizRequest, deleteQuizRequestError, deleteQuizRequestSuccess } from "../../../slices/teams/members/DeleteQuizSlice";

export const DeleteQuizAPI = (id) => {
   

    const url = `${endpoints.deleteQuiz}/${id}`;

    return async (dispatch) => {
        try {
            dispatch(deleteQuizRequest());
            const response = await axiosInstance({
                method: "DELETE",
                url: url,
                // headers: { "Content-Type": "application/json" },
            })
            return dispatch(deleteQuizRequestSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(deleteQuizRequestError(_error));
        }
    };
};
